import { Box, Tag, TagLabel } from "@chakra-ui/react";
import { TransactionStatus } from "../API";

type StatusConfigEntry = {
  label: string;
  colorScheme: string;
  dotColor: string;
};

const syncStatusConfig: Record<TransactionStatus, StatusConfigEntry> = {
  [TransactionStatus.booked]: {
    label: "Gebucht",
    colorScheme: "success",
    dotColor: "success.500",
  },
  [TransactionStatus.draft]: {
    label: "Entwurf",
    colorScheme: "gray",
    dotColor: "grayCool.500",
  },
  [TransactionStatus.extracted]: {
    label: "Extrahiert",
    colorScheme: "warning",
    dotColor: "warning.500",
  },
  [TransactionStatus.failed]: {
    label: "Fehler",
    colorScheme: "error",
    dotColor: "error.500",
  },
};

type ExportStatus = "exported";

const exportStatusConfig: Record<ExportStatus, StatusConfigEntry> = {
  exported: {
    label: "Exportiert",
    colorScheme: "purple",
    dotColor: "purple.500",
  },
};

type StatusChipProps =
  | { type: "sync"; status: TransactionStatus }
  | { type: "export"; status: ExportStatus };

const StatusChip = (props: StatusChipProps) => {
  const config =
    props.type === "sync"
      ? syncStatusConfig[props.status]
      : exportStatusConfig[props.status];

  if (!config) return null;

  return (
    <Tag
      size="sm"
      colorScheme={config.colorScheme}
      variant="subtle"
      borderRadius="full"
      data-color-scheme={config.colorScheme}
    >
      <Box
        w="6px"
        h="6px"
        borderRadius="full"
        bg={config.dotColor}
        mr="1.5"
      />
      <TagLabel>{config.label}</TagLabel>
    </Tag>
  );
};

export default StatusChip;
